/**
 * Языки интерфейса (B1).
 *
 * Английский — исходный: на нём пишутся ключи и он же запасной, если перевода
 * нет. Остальные — переводы. Названия языков написаны на них самих: человек,
 * ищущий свой язык в списке, не обязан знать, как он называется по-английски.
 */
export const languages = [
  { code: 'en', label: 'English' },
  { code: 'ru', label: 'Русский' },
  { code: 'es', label: 'Español' },
  { code: 'pt', label: 'Português' },
  { code: 'de', label: 'Deutsch' },
  { code: 'it', label: 'Italiano' },
  { code: 'fi', label: 'Suomi' },
  { code: 'ro', label: 'Română' },
  { code: 'uk', label: 'Українська' },
  { code: 'kk', label: 'Қазақша' },
] as const;

export type LanguageCode = (typeof languages)[number]['code'];

export const DEFAULT_LANGUAGE: LanguageCode = 'en';

export const supportedLanguages: LanguageCode[] = languages.map((item) => item.code);

export const isSupported = (code: string): code is LanguageCode =>
  (supportedLanguages as string[]).includes(code);
